import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaTimes } from "react-icons/fa";
import { closeSheet } from "../../../store/sheetToggler";
import { generateLinkWithLang } from "../../../utils/linkGenerator";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { selectSelectedCurrency } from "../../../store/user";
// import { setCartLength, setSelectWidgetProducts } from '../../../store/widgetCart';
import { ProductBoxCartSheet } from "../../../components/general/productBoxCartSheet";
import CustomButton from "../../../components/general/button";
import { Sheet } from "../../../components/ui/sheet";
import getSymbolFromCurrency from "currency-symbol-map";
import { IoReturnUpBackOutline } from "react-icons/io5";
import {
  BASKET_CACHE_KEY,
  HandleLocalStorage,
} from "../../../utils/handleLocalStorage";
import AdminCosts from "../../../components/steps/components/adminCosts";
import useCart from "../../../hooks/cart/useCart";
import services from '../../../services';
import { ProductBoxCart } from './productBoxCart';
import useIsExactDomain from "../../../hooks/cart/useIsExactDomain";
// import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { FiChevronDown } from "react-icons/fi";
import { selectProducts } from "../../../store/products";
// import ShowCurrenciesV2 from "../../../utils/showCurrenciesV2";
import { stripeAUDPromise, stripeUKPromise, stripeUSDPromise } from "../../../components/steps/oneClickCheckout/stripePromises";
import { OneClickCheckout } from "../../../components/steps/oneClickCheckout";

// const stripePromise = loadStripe('pk_live_51O25i3EpTLP297fAAuxdDPYNX04EtyEqgVKa0Wxl7bdAG1elEa0Gr6kbOKsw1ntgCUX4bkSWKv7m5cF4GZ6POGM600TRvCpUVI');

export const CartSheet = ({ onAddQty, onReduceQty, onRemove }) => {
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [ukCitizenInfo,setUkCitizenInfo]=useState()
  const dispatch = useDispatch();
  const isUsa = useIsExactDomain('us.matwproject.org');
  const [selectedSubscribe, setSelectedSubscribe] = useState("one-off");
  const [userProductsCount, setUserProductsCount] = useState(0);
  const [topProducts, setTopProducts] = useState([0, 0, 0, 0]);

  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const getInitialBasket = () =>
    JSON.parse(localStorage.getItem(BASKET_CACHE_KEY)) || {};

  const [baskets, setBaskets] = useState(getInitialBasket());
  const { basketStates, setBasketStates, notifyStorageUpdate, handleCheckProduct, handleAddToGiving, handleRemoveProduct } = useCart();
  let basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
  const [products, setProducts] = useState(baskets.products || []);
  // const [total, setTotal] = useState(baskets.grandTotal || 0);
  const [isCheckoutDisabled, setIsCheckoutDisabled] = useState(false);
  const checkoutRef = useRef(null);

  const allProducts = useSelector((state) => selectProducts(state));

  const updateBasketState = () => {
    const updatedBasket = getInitialBasket();
    setBaskets(updatedBasket);
    setProducts(updatedBasket.products || []);
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === BASKET_CACHE_KEY) {
        updateBasketState();
      }
    };
    const handleLocalStorageChange = (event) => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
    };
    window.addEventListener("localStorageUpdated", handleLocalStorageChange);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleAdminCost = (value, isCustomAdminFee) => {
    // Get fresh data from localStorage
    let tempBasket = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));

    if (tempBasket?.products?.length && tempBasket.products[0]?.product) {
      let tempGrandTotal = value;

      tempBasket.products.map(item => {
        item.product ? (tempGrandTotal += item.total) : (tempGrandTotal = value);
        return null;
      });

      // Update the basket with new values
      tempBasket.customAdminFee = isCustomAdminFee;
      tempBasket.adminCost = Number(value);
      tempBasket.grandTotal = Number(tempGrandTotal);
      tempBasket.recurring ? setSelectedSubscribe(tempBasket.recurring) : setSelectedSubscribe('one-off');

      if (selectedCurrencyStore && !tempBasket.currency) {
        tempBasket.currency = selectedCurrencyStore;
      }

      // console.log('selectedSubscribe', selectedSubscribe);

      setBasketStates(tempBasket);
      HandleLocalStorage(tempBasket);
      setUserProductsCount(userProductsCount + 1);
      notifyStorageUpdate()
    }
  };

  useEffect(() => {
    if (
      basketStatesFromLocalStorage &&
      JSON.stringify(products) !==
      JSON.stringify(basketStatesFromLocalStorage.products)
    ) {
      setProducts(basketStatesFromLocalStorage.products);
    }
  }, [basketStatesFromLocalStorage, products]);

  const groupedProducts =
    basketStatesFromLocalStorage?.products.length &&
      basketStatesFromLocalStorage?.products[0].product
      ? Object.values(
        basketStatesFromLocalStorage?.products.length &&
        basketStatesFromLocalStorage?.products[0].product &&
        basketStatesFromLocalStorage?.products.reduce((acc, item) => {
          const key = item.product.creator; // Use creator as the unique identifier

          if (!acc[key]) {
            acc[key] = { ...item }; // Store the first instance of the product
          } else {
            // Sum up quantities and totals for duplicate products
            acc[key].quantity += item.quantity;
            acc[key].total += item.total;
          }

          return acc;
        }, {}),
      )
      : [];
  const ShowCurrencies2 = (currency, _price) => {
    let tempCurrency = currency && currency.toUpperCase();
    let price = Number(_price);
    const options = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    if (price && Number(price) % 1 !== 0) {
      price = Number(price).toLocaleString("en", options);
    }
    let _final = "";
    price = price ? price.toLocaleString() : 0;
    switch (tempCurrency) {
      case "GBP":
        _final = `${getSymbolFromCurrency(tempCurrency.toLowerCase())}${price}`;
        break;
      case "EUR":
        _final = `${getSymbolFromCurrency(tempCurrency.toLowerCase())}${price}`;
        break;
      case "MYR":
        _final = `${price}`;
        break;
      case "IDR":
        _final = `Rp${price}`;
        break;
      case "AED":
        _final = `Dh${price}`;
        break;
      default:
        _final = `$${price}`;
        break;
    }
    return _final;
  };

  const getAddOnProducts = async () => {
    try {
      const response = await services.getSideAddonProducts();

      function uniqBy(a) {
        const seen = {};
        return a.filter(item => {
          const k = item.creator;
          return seen.hasOwnProperty(k) ? false : (seen[k] = true);
        });
      }

      // ✅ Filter by status and exclude "PAO-QB-PL-25-030"
      response.data = response.data.filter(
        item => Number(item.status) === 1 && item.creator !== 'PAO-QB-PL-25-030'
      );

      const tempNewProducts = uniqBy(response.data);

      // ✅ Use only addon products (no hardcoded local products)
      const mergedAddOnProducts = [...tempNewProducts].filter(Boolean);

      sortAddOnProducts(mergedAddOnProducts, selectedCurrencyStore);
    } catch (error) {
      console.error('error========', error);
    }
  };
  
  const sortAddOnProducts = (products, currency) => {
  const currencyKey = currency.toLowerCase();

  const sorted = products
    .filter(p => typeof p[currencyKey] === 'number') // ensure valid values
    .sort((a, b) => b[currencyKey] - a[currencyKey]); // descending sort

  // Optional: move specific product after sorting
  const index = sorted.findIndex(item => item.creator === "PAO-EMR-2025-002");
  if (index !== -1) {
    const rddProduct = sorted.splice(index, 1)[0]; // remove from current position
    sorted.splice(1, 0, rddProduct); // insert at index 1
  }

  setUserProductsCount(userProductsCount + 1);
  setTopProducts(sorted);
};


  useEffect(() => {
    if (allProducts && Object.keys(allProducts).length) {
      topProducts[0] && topProducts[0][selectedCurrencyStore.toLowerCase()] && sortAddOnProducts(topProducts, selectedCurrencyStore);
      selectedCurrencyStore && getAddOnProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrencyStore, allProducts])

  const scrollToSheet = useRef(null);

  const getStripePromise = (paymentFlow) => {
    switch (paymentFlow) {
      case 'USD':
        return stripeUSDPromise;
      case 'AUD':
        return stripeAUDPromise;
      case 'UK':
      case 'FR':
      case 'OTHER':
      default:
        return stripeUKPromise;
    }
  };
  const handleUserInfo = userInfo => {
    setUkCitizenInfo({
      city: userInfo.city,
      address: userInfo.address,
      postalCode: userInfo.postal_code,
      isUkTaxPayer:userInfo.isUkTaxPayer,
    })
    let tempBasket = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
    let tempPaymentFlow = userInfo.isUkTaxPayer ? 'UK' : tempBasket.paymentFlow
    tempBasket.user = userInfo;
    tempBasket.paymentFlow = tempPaymentFlow;
    tempBasket.user.payment_flow = tempPaymentFlow;
    tempBasket.donor = {
      address: userInfo.address,
      city: userInfo.city,
      country: userInfo.country,
      countryCode: userInfo.countryCode,
      email: userInfo.email,
      name: userInfo.name,
      phone: userInfo.phone,
      postal_code: userInfo.postal_code,
      isUkTaxPayer: userInfo.isUkTaxPayer,
      acceptSms: userInfo.isConsentChecked,
      phone_country_name: userInfo.phone_country_name,
      phone_country_code: userInfo.phone_country_code,
    }
    console.log("user info updated=", userInfo,tempBasket)
    userInfo.name && HandleLocalStorage(tempBasket);
  }

  const isCheckoutBtnDisabled = () => {
    const isUkTaxPayer = ukCitizenInfo?.isUkTaxPayer;
    const hasRequiredInfo =
        ukCitizenInfo?.city && ukCitizenInfo?.address && ukCitizenInfo?.postalCode;
    return isUkTaxPayer && !hasRequiredInfo;
  };


  return (
    <>
      <Sheet
        refTo={scrollToSheet}
      >
        <div className={`h-full flex flex-col`}>
          <div
            className={`px-4 pt-3 md:pt-6 bg-[#0286c3] ${isUsa ? "mb-4 md:mb-6" : ""}`}
          >
            <div className="flex justify-between gap-6 items-center">
              <div className="text-white cursor-pointer">
                <CustomButton
                  onClick={() => dispatch(closeSheet())}
                  title="add more items"
                  className="!text-sm !h-[32px] !font-signika !rounded-none"
                />
              </div>
              <div className="text-white font-light cursor-pointer h-[24px] w-[24px] rounded-full flex justify-center items-center">
                <FaTimes
                  onClick={() => dispatch(closeSheet())}
                  className="font-extrabold text-2xl"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
          <div className="px-4 md:px-10 bg-[#0286c3] mt-4">
            {basketStatesFromLocalStorage?.products.length &&
              basketStatesFromLocalStorage?.products[0].product &&
              groupedProducts.length > 0 ? (
              groupedProducts.map((item, index) => (
                <div key={`items${index}`}>
                  <ProductBoxCartSheet
                    product={item}
                    onAddQty={() => onAddQty(item.product)}
                    onReduceQty={() => onReduceQty(item.product)}
                    // onUpdateQty={() => onUpdateQty(item.product, 444)}
                    onRemove={() => onRemove(item.product)}
                    item={item.product}
                  />
                </div>
              ))
            ) : (
              <p className="font-signika text-xl text-white font-semibold text-center">
                No Items found
              </p>
            )}
          </div>
          <div className="px-4 md:px-10 bg-[#0286c3] pb-4 md:pb-10 mt-auto">
            <div className="flex flex-col gap-2 md:gap-4 mt-auto">
              {basketStatesFromLocalStorage &&
                basketStatesFromLocalStorage.grandTotal > 0 && (
                  <div className={`mt-6 md:mt-8`}>
                    <div className="flex flex-col gap-3">
                      {/* {isUsa && ( */}
                      <div className="border-b border-[#00afff80] pb-2 md:pb-4">
                        <AdminCosts
                          basketStates={basketStates}
                          setBasketStates={setBasketStates}
                          selectedSubscribe={selectedSubscribe}
                          currency={
                            selectedCurrencyStore
                              ? selectedCurrencyStore
                              : basketStates?.currency
                          }
                          onChange={(e, isCustomAdminFee) => handleAdminCost(e, isCustomAdminFee)}
                          isSheet={true}
                        />
                      </div>
                      {/* )} */}
                      <div className="flex flex-col items-center gap-2">
                        <h2 className="font-signika text-xl md:text-2xl font-bold text-white mb-2">
                          Want to make a bigger impact?
                        </h2>
                        {topProducts.map((product, index) => {
                          return <ProductBoxCart
                            key={`product-${index}`}
                            product={product}
                            onCheck={handleCheckProduct}
                            onAdd={handleAddToGiving}
                            onRemove={handleRemoveProduct}
                            currency={selectedCurrencyStore}
                            stateVariableObj={{ productName: product.name }}
                            _lang={'eng'}
                            linkBtnClasses={product.linkBtnClasses || ''}
                            isStaticProduct={['Zakat Calculator'].includes(product.product_type)}
                            hideCount
                            staticLink={
                              product.product_type
                                ? product.short_description
                                : ''
                            }
                            staticLinkText={
                              product.product_type ? product.name : ''
                            }
                          />
                        })}
                      </div>
                      <div className="flex flex-col gap-2 justify-between sticky bottom-0 bg-[#0286c3] h-[72px] z-10">
                        <div className="border-b border-[#00afff80] h-[10px] w-full"></div>
                        <div className="flex items-center gap-4 justify-between">
                          <p className="font-signika text-3xl md:text-4xl font-bold text-white">
                            Total
                          </p>
                          {/* {shouldRenderBounceBtn && ( */}
                          <div
                            className={`h-8 w-8 bg-[#FF005D] flex items-center justify-center cursor-pointer bounce-checkout-btn`}
                            onClick={() => {
                              checkoutRef.current?.scrollIntoView({ behavior: "smooth" });
                              // setShowBounceBtn(false);
                            }}
                          >
                            <FiChevronDown className="text-white" size={24} />
                          </div>
                          {/* )} */}
                          <p className="font-signika text-2xl md:text-4xl font-bold text-white">
                            {selectedCurrencyStore === "MYR" ||
                              selectedCurrencyStore === "SGD" ? (
                              <span className="text-sm ml-0.5">
                                {selectedCurrencyStore}
                              </span>
                            ) : (
                              ""
                            )}
                            {ShowCurrencies2(selectedCurrencyStore, basketStatesFromLocalStorage.grandTotal)}
                            {/* {ShowCurrencies2(
                              selectedCurrencyStore,
                              basketStatesFromLocalStorage.grandTotal -
                                (!isUsa
                                  ? basketStatesFromLocalStorage?.adminCost
                                  : 0),
                            )} */}
                          </p>
                        </div>
                        <div className="border-t border-[#00afff80] h-[10px] w-full"></div>
                      </div>
                    </div>
                  </div>
                )}
              {/* {isUsa && ( */}
              <>
                {basketStatesFromLocalStorage?.grandTotal > 0 && (
                  <Elements stripe={getStripePromise(basketStatesFromLocalStorage?.paymentFlow)}>
                    <OneClickCheckout
                      setUserInfoToLocalStorage={(e) => handleUserInfo(e)}
                      onValidationChange={(hasError) => {
                        // console.log("validation=",hasError)
                        setIsCheckoutDisabled(hasError)
                      }}
                    />
                  </Elements>
                )}
              </>
              {/* )} */}
              <div className="bg-[#0286c3] flex gap-3 group">
                <CustomButton
                  onClick={() => dispatch(closeSheet())}
                  title="Back"
                  icoLeft={<IoReturnUpBackOutline className="mr-2" />}
                  className="!h-[52px] md:!h-[56px] !font-signika uppercase !w-full font-bold checkout-btn-bg !text-[20px] md:!text-2xl flex-1 !bg-[#00a4da3f] hover:!bg-[#00a4da6e] !rounded-none"
                />
                {basketStatesFromLocalStorage &&
                  basketStatesFromLocalStorage.grandTotal > 0 && (
                    <div ref={checkoutRef} className="w-full">
                      <CustomButton
                        // disabled={isCheckoutDisabled}
                        onClick={() => {
                          localStorage.setItem(
                            "IS_DAILY_DONATION",
                            JSON.stringify(false),
                          );
                          navigate(generateLinkWithLang("/checkout", lang));
                          dispatch(closeSheet());
                        }}
                        disabled={isCheckoutBtnDisabled()}
                        title="Checkout"
                        className="!h-[52px] md:!h-[56px] !font-signika uppercase !w-full font-bold checkout-btn-bg !text-[20px] md:!text-2xl flex-grow !rounded-none"
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </Sheet>
    </>
  );
};